import { CategoryTreeNode } from '@/server/services/core/category/models';

export const normalizeCategoryTreePayload = (payload: unknown): CategoryTreeNode[] => {
    if (Array.isArray(payload)) {
        return payload;
    }

    if (payload && typeof payload === 'object' && 'content' in payload) {
        const content = (payload as { content: unknown }).content;

        if (Array.isArray(content)) {
            return content;
        }
    }

    return [];
};
